import VueRouter from 'vue-router';
import Vue from 'vue';

import {EmailEntryPage} from './pages/forms/email-entry/email-entry';
import {ClubCardVerifyPage} from './pages/forms/clubcard-verify/clubcard-verify';
import {SecurityEntryPage} from './pages/forms/security-entry/security-entry';
import {ClubCardHasQuestionPage} from './pages/forms/clubcard-has-question/clubcard-has-question';
import {ClubCardEntryPage} from './pages/forms/clubcard-entry/clubcard-entry';
import {EmailRegisteredPage} from './pages/messages/email-registered/email-registered';
import {RegistrationErrorPage} from '@/pages/messages/registration-error/registration-error';
import {ClubCardChooseRewardPage} from '@/pages/forms/clubcard-choose-reward/clubcard-choose-reward';
import {ClubCardDetailsEntryPage} from '@/pages/forms/clubcard-details-entry/clubcard-details-entry';
import {AddressEntryPage} from '@/pages/forms/address-entry/address-entry';
import { FreshRegistrationPage } from './pages/forms/fresh-registration/fresh-registration';

export const routes = [
  //step 1
  {path: '/email-entry', component: EmailEntryPage, meta: {step: 1, hideBackInitial: true, hideBack: true}},
  //step 2
  {path: '/clubcard-verify', component: ClubCardVerifyPage, meta: {step: 2}},
  {path: '/clubcard-has-question', component: ClubCardHasQuestionPage, meta: {step: 2}},
  {path: '/clubcard-entry', component: ClubCardEntryPage, meta: {step: 2}},
  //clubcard/clubcard-choose-reward
  {path: '/clubcard-choose-reward', component: ClubCardChooseRewardPage, meta: {step: 2}},
  {path: '/clubcard-details-entry', component: ClubCardDetailsEntryPage, meta: {step: 2, alwaysBackTo: '/clubcard-choose-reward'}},
  {path: '/address-entry', component: AddressEntryPage, meta: {step: 2, hideSteps: true}},

  // step 3 - fresh mailing list
  {path: '/fresh-registration', component: FreshRegistrationPage, meta: {step: 3}},

  // step 3
  {path: '/security-entry', component: SecurityEntryPage, meta: {step: 3}},
  {path: '/email-registered', component: EmailRegisteredPage, meta: {step: 1, hideSteps: true}},
  {path: '/registration-error', component: RegistrationErrorPage, meta: {step: 1, hideSteps: true}},

];

Vue.use(VueRouter);

export const router = new VueRouter({routes: routes, mode: DEV_MODE ? undefined: 'abstract' });



// WEBPACK FOOTER //
// ./src/router.ts